import { useQuery } from '@tanstack/react-query';
import { QUOTE_MAX_GUESTS, QUOTE_MIN_GUESTS } from '@casa-aragon/utils';

import { templatesApi } from '@/lib/api/templates';

/** What each plan's quote comes to for a guest count (no auth); disabled outside the quotable range. */
export function usePublicPlanPrices(guests: number | undefined) {
  const enabled = !!guests && guests >= QUOTE_MIN_GUESTS && guests <= QUOTE_MAX_GUESTS;
  return useQuery({
    queryKey: ['public-plan-prices', guests],
    queryFn: async () => (await templatesApi.getPublicPlanPrices(guests as number)).data,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
